module.exports = function(viewData, vue) {
  vue.data = function() {
    return viewData;
  }

  if (typeof vue.computed == 'undefined') {
    vue.computed = {};
  }

  /*
  for (var key in viewData) {
    if (viewData.hasOwnProperty(key)) {
      (function(key, value) {
        vue.computed[key] = {
          get() {
            var val = typeof viewData[key] == 'undefined' ? value : viewData[key];
            // console.log('get', key, val);
            return val;
          },
          set(val) {
            // console.log('set', key, val);
            viewData[key] = val;
          }
        };
      })(key, viewData[key]);
    }
  }
  */

  return vue;
};
